// El callback default de DatabaseModel.sendRequest desempaqueta `res.data.dto`
// cuando es truthy y resuelve con el dto directamente; cuando dto es null
// resuelve con el ResponseDto wrapper completo. Resultado: el cliente no sabe
// si recibe la entidad ya desempaquetada o el wrapper.
//
// Este helper normaliza ambos casos.

export function unwrapDto(res) {
  if (res === null || res === undefined) return null;
  if (typeof res !== 'object' || Array.isArray(res)) return res;
  // Objeto vacio: probablemente ResponseDto serializado con @JsonInclude(NON_NULL)
  // y todos los campos null (caso "no hay ficha" en produccion).
  if (Object.keys(res).length === 0) return null;
  // Firma del ResponseDto Java: dto, error, list, totalCount, funcionesAgregadas, resource.
  // Si trae al menos dos de esas propiedades es wrapper (en produccion los null se
  // omiten, asi que con dos basta para distinguirlo de una entidad de dominio).
  var flags = ('error' in res ? 1 : 0) + ('totalCount' in res ? 1 : 0)
    + ('list' in res ? 1 : 0) + ('dto' in res ? 1 : 0);
  if (flags >= 2) {
    if (res.dto !== undefined && res.dto !== null) return res.dto;
    // Solo devolvemos `list` si trae elementos. Una lista vacia en el wrapper
    // no implica "hay datos vacios" sino "no hay nada"; los clientes que
    // esperan lista usan `unwrapDto(res) || []` y convierten el null a [].
    if (Array.isArray(res.list) && res.list.length > 0) return res.list;
    return null;
  }
  return res;
}

export default unwrapDto;
